import React from 'react';
import { string } from 'prop-types';
import { Icon, Icons, Tooltip, styled } from '@nextiva/next-ui-components';
import { pxToRem } from 'utils/pxToRemConverter';
import sassVars from 'styles/application/_base/_variables.scss';

const HintCss = styled('div')`
  display: flex;
  align-items: center;
  font-size: ${pxToRem('10px')};
  font-weight: 900;
  line-height: 1px;
  font-family: Lato, sans-serif;
  color: ${sassVars.secondaryColor};
  text-transform: uppercase;
`;

const TipCss = styled('div')`
  font-size: ${pxToRem('14px')};
`;

const SvgIcon = styled(Icon)`
  display: inline;
  margin: 0 0 0 8px;
  &.MuiSvgIcon-root {
    width: 15px;
    height: 15px;
  }
`;

export const Hint = ({ tool = 'TOOL', tip = null }) => {
  return (
    <HintCss>
      {tool}
      {tip && (
        <Tooltip
          placement="bottom"
          title={<TipCss>{tip}</TipCss>}
          PopperProps={{
            popperOptions: {
              modifiers: {
                offset: {
                  enabled: true,
                  offset: '0px, -10px',
                },
              },
            },
          }}
        >
          <SvgIcon icon={Icons.helpSolid} />
        </Tooltip>
      )}
    </HintCss>
  );
};

Hint.propTypes = {
  tool: string.isRequired,
  tip: string,
};

export default Hint;
